// extracted by mini-css-extract-plugin
module.exports = {"container":"lesson-title_container__2TaHA","tabs":"lesson-title_tabs__kjXMW","top":"lesson-title_top__22rnz","title":"lesson-title_title__2p224","full":"lesson-title_full__1i3O8"};